import { PosthogUtil } from './posthog';

const error = (_error: Error) => {
	void _error;
};

const user = (user: { email: string; id: string }) => {
	PosthogUtil.identifyUser(user.id, { email: user.email });
};

export const logger = {
	error,
	user,
};
